package com.essntl.core.settings.data.supabase.configuration

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [ConfigurationSupabaseDataSource::class])
class ConfigurationSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<ConfigurationDto> {
    override val tableName: String = "tenant_configuration"
}